import { render, staticRenderFns } from "./SchoolContactForm.vue?vue&type=template&id=0c24c6b9&scoped=true&"
import script from "./SchoolContactForm.vue?vue&type=script&lang=js&"
export * from "./SchoolContactForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c24c6b9",
  null
  
)

export default component.exports